import { render, staticRenderFns } from "./AddExamBigClass.vue?vue&type=template&id=0928769d&scoped=true&"
import script from "./AddExamBigClass.vue?vue&type=script&lang=js&"
export * from "./AddExamBigClass.vue?vue&type=script&lang=js&"
import style0 from "./AddExamBigClass.vue?vue&type=style&index=0&id=0928769d&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0928769d",
  null
  
)

export default component.exports